import momentTz from 'moment-timezone';
import React, { useMemo } from 'react';

export const withBookingDetails =
  (Component) =>
  ({ booking, listing }) => {
    const bookingStart = booking?.dts_start || [];
    const bookingEnd = booking?.dts_end || [];
    const timeZoneId = booking?.start.timezone.id || '';

    const displayDate = useMemo(() => {
      return momentTz.tz(bookingStart, timeZoneId).format('ddd, MMM D, YYYY');
    }, [bookingStart]);

    const displayTime = useMemo(() => {
      const startTime = momentTz.tz(bookingStart, timeZoneId).format('LT');
      const endTime = momentTz.tz(bookingEnd, timeZoneId).format('LT');
      return `${startTime} - ${endTime}`;
    }, [bookingStart, bookingEnd]);

    const city = listing?.city || '';
    const state = listing?.state || '';
    const displayLocation = `${city}, ${state}`;
    const numberOfGuests = booking?.number_of_guests || 0;
    const displayAttendees =
      1 < numberOfGuests ? `${numberOfGuests} people` : '1 person';

    return (
      <Component
        displayDate={displayDate}
        displayTime={displayTime}
        displayLocation={displayLocation}
        displayAttendees={displayAttendees}
      />
    );
  };
